import React from 'react';
import styles from './SingleUser.module.scss';
import UserHeader from 'component/molecules/users/single-user/UserHeader';
import RoundedTabs from 'component/atom/Tabs/RoundedTabs';
import UserDetails from 'component/molecules/users/single-user/components/details/UserDetails';
import AuthUser from 'component/molecules/users/single-user/components/authentication/AuthUser';
import { useParams } from 'react-router-dom';
import { useFetch } from 'hooks/useFetch';
import { userEndpoints } from 'hooks/endpoints';
import LoadingSpinner from 'component/Custom/LoadingSpinner/LoadingSpinner';
import Activity from 'component/molecules/users/single-user/components/activity/Activity';
import Usage from 'component/molecules/users/single-user/components/usage/Usage';
import Loader from 'component/atom/loader/Loader';
const UserProfileTemplate = () => {
  const { id } = useParams();
  const {
    data: data,
    isFetching: isFetching,
    refetch: refetchUser,
  } = useFetch(['userDetailsById', id], userEndpoints?.getUserById(id), {
    enabled: id != null,
  });
  const user = data?.data;

  const tabs = [
    {
      label: 'Details',
      content: <UserDetails user={user?.user?.[0]} id={id} />,
    },
    { label: 'Authentication', content: <AuthUser /> },
    {
      label: 'Activity',
      content: <Activity userId={user?.user[0]?.userId} />,
    },
    { label: 'Usage', content: <Usage userId={user?.user[0]?.userId} /> },
  ];

  if (isFetching) {
    return <Loader isComponent />;
  }

  return (
    <div className={styles.cont}>
      <UserHeader id={id} user={user} refetchUser={refetchUser} />
      <RoundedTabs tabs={tabs} padding />
    </div>
  );
};

export default UserProfileTemplate;
